module.exports = __webpack_public_path__ + "img/bathtub.1ee147c3.svg";